import React, { FC, Suspense, useEffect } from 'react';

import FallbackPage from './FallbackPage';
import { isLoggedIn } from '../../../shared/libs/auth/auth';
import { useHistory } from 'react-router';

interface ProtectedRouteProps {
    redirectPath?: string;
    useSignUp?: boolean;
}
const ProtectedRoute: FC<ProtectedRouteProps> = ({ redirectPath, useSignUp, children }) => {
    const history = useHistory();
    if (!isLoggedIn()) {
        if (redirectPath) {
            history.push(redirectPath);
            return null;
        }
        useEffect(() => {
            if (useSignUp) {
                window.location.href =
                    process.env.REACT_APP_AUTH_ENDPOINT +
                    '/signup?redirect_uri=' +
                    window.encodeURIComponent(window.location.href);
            } else {
                window.location.href =
                    process.env.REACT_APP_AUTH_ENDPOINT +
                    '/login?redirect_uri=' +
                    window.encodeURIComponent(window.location.href);
            }
        }, []);
        return null;
    }

    return <Suspense fallback={<FallbackPage />}>{children}</Suspense>;
};

export default ProtectedRoute;
